export default __webpack_public_path__ + "i18n/en_AU.86519f2d8bdda40adaef8aa46659a45a.json";